import { Fragment } from 'react';
import { Menu } from '@pocketlaw/tetris';
import { useField } from 'formik';
import { FormSubmitButton } from './FormSubmitButton';
export function MultilineTextField() {
    const [field] = useField('value');
    return (<Fragment>
      <Menu.TextArea {...field}/>
      <FormSubmitButton />
    </Fragment>);
}
